import {
  PROFILE_REPORTS_JOYRIDE_LAYOUT_MAX_WAIT_MS,
  PROFILE_REPORTS_JOYRIDE_LAYOUT_STABLE_MS,
} from '../constants'

const SCROLLABLE_OVERFLOW_VALUES = new Set(['auto', 'scroll', 'overlay'])

const getTargetLayoutSnapshot = (target) => {
  const { top, left, width, height } = target.getBoundingClientRect()
  return `${top}|${left}|${width}|${height}`
}

export const getScrollParents = (element) => {
  const parents = []
  let parent = element.parentElement

  while (parent) {
    const { overflow, overflowX, overflowY } = window.getComputedStyle(parent)
    const isScrollable = [overflow, overflowX, overflowY].some((value) =>
      SCROLLABLE_OVERFLOW_VALUES.has(value)
    )

    if (
      isScrollable &&
      (parent.scrollHeight > parent.clientHeight ||
        parent.scrollWidth > parent.clientWidth)
    ) {
      parents.push(parent)
    }

    parent = parent.parentElement
  }

  return parents
}

export const scrollJoyrideTargetIntoView = (target) => {
  getScrollParents(target).forEach((parent) => {
    const targetRect = target.getBoundingClientRect()
    const parentRect = parent.getBoundingClientRect()
    const nextScrollTop =
      targetRect.top -
      parentRect.top +
      parent.scrollTop -
      parent.clientHeight / 2 +
      targetRect.height / 2

    parent.scrollTop = Math.max(0, nextScrollTop)
  })

  target.scrollIntoView({
    behavior: 'instant',
    block: 'center',
    inline: 'nearest',
  })
}

export const waitForStableJoyrideTarget = (
  selector,
  {
    stableMs = PROFILE_REPORTS_JOYRIDE_LAYOUT_STABLE_MS,
    maxWaitMs = PROFILE_REPORTS_JOYRIDE_LAYOUT_MAX_WAIT_MS,
  } = {}
) =>
  new Promise((resolve) => {
    let stableTimer
    let maxTimer
    let resizeObserver
    let mutationObserver
    let lastSnapshot = ''

    const cleanup = () => {
      clearTimeout(stableTimer)
      clearTimeout(maxTimer)
      resizeObserver?.disconnect()
      mutationObserver?.disconnect()
    }

    const evaluate = () => {
      const target = document.querySelector(selector)
      if (!target) return

      const { width, height } = target.getBoundingClientRect()
      if (width === 0 || height === 0) return

      const nextSnapshot = getTargetLayoutSnapshot(target)
      if (nextSnapshot === lastSnapshot) {
        if (!stableTimer) {
          stableTimer = setTimeout(() => {
            cleanup()
            resolve(target)
          }, stableMs)
        }
        return
      }

      lastSnapshot = nextSnapshot
      clearTimeout(stableTimer)
      stableTimer = null

      resizeObserver?.disconnect()
      resizeObserver = new ResizeObserver(evaluate)
      resizeObserver.observe(target)
    }

    maxTimer = setTimeout(() => {
      cleanup()
      resolve(document.querySelector(selector))
    }, maxWaitMs)

    mutationObserver = new MutationObserver(evaluate)
    mutationObserver.observe(document.body, { childList: true, subtree: true })
    evaluate()
  })
